const stateMetaKey = '__wjSourceStateMeta';
export function createMeta(ctor) {
  if (!ctor[stateMetaKey]) {
    Object.defineProperty(ctor, stateMetaKey, {
      value: new StateMeta(),
      enumerable: false,
      configurable: false
    });
  }
  return ctor[stateMetaKey];
}
export function getStateMeta(ctor) {
  return createMeta(ctor);
}
export class StateMeta {
  constructor() {
    /**
     * action的cgi依赖，action的调用定义
     */
    this.actionInfos = {};
    /**
     * state里面某些属性的schema定义
     */
    this.stateSchemas = {};
    /**
     * 启动代理的属性
     */
    this.proxyProperties = [];
  }
  setActionInfo(actionName, actionInfo) {
    this.actionInfos[actionName] = actionInfo;
  }
  registerAction(actionInfo) {
    this.actionInfos[actionInfo.actionName] = actionInfo;
  }
  setStateSchema(prop, schema) {
    this.stateSchemas[prop] = schema;
  }
}
//# sourceMappingURL=StateMeta.js.map
